import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { TableLanding } from 'src/ui/library/Table/extensions';
import Button from 'src/ui/library/Button';
import ListIcon from '@material-ui/icons/List';
import DeleteIcon from '@material-ui/icons/Delete';
import { ConfirmDialog } from 'src/ui/library/Dialog';
import intl from 'react-intl-universal';
import RelatedEntitiesDetailModal from './RelatedEntitiesDetailModal';
import { fetchRelatedList, deleteRelatedRecord } from 'src/services/cms.service';

class RelatedEntitiesLanding extends React.Component {
  static propTypes = {
    /** Id of the top level record */
    topLevelRecordId: PropTypes.string.isRequired,
    /** Id of a parent record - used for generating table data.
     *  Can be same as topLevelRecordId */
    parentRecordId: PropTypes.string.isRequired,
    /** Entity set name of parent record*/
    parentEntitySetName: PropTypes.string.isRequired,
    /** Entity logical name of parent record */
    parentEntityName: PropTypes.string.isRequired,
    /** Relationship name - used in api calls */
    relationshipName: PropTypes.string.isRequired,
    /** Display name of the entity */
    displayName: PropTypes.string.isRequired,
    /** Area - used for labels*/
    area: PropTypes.string.isRequired,
    /** Additional props - used to get services and other props  */
    additionalProps: PropTypes.object.isRequired,
    /** Func reference to get additional props for additional levels of relationships.
     * For example: A table within a modal of a related record.
     */
    getAdditionalPropsForRelatedEntities: PropTypes.func,
  };

  constructor(props) {
    super(props);
    const { additionalProps } = props;
    let fetch = fetchRelatedList;
    let del = deleteRelatedRecord;
    // let onModifyResponse;

    if (additionalProps) {
      fetch = additionalProps.fetch ? additionalProps.fetch : fetch;
      // onModifyResponse = additionalProps.onModifyResponse ? additionalProps.onModifyResponse : null;
    }
    this.state = {
      openDrawer: false,
      relatedRecordId: '00000000-0000-0000-0000-000000000000',
      isCreate: false,
      showConfirmDialog: false,
      entityName: '',
      fetch,
      // onModifyResponse,
      del,
    };
  }

  onTableChange = (actionType, data, ...otherData) => {
    switch (actionType) {
      case 'rowClick':
        const rowIndex = data.rowClicked.rowIndex;
        const row = data.model.rows[rowIndex];
        row.forEach(column => {
          if (column.columnId === 'id') {
            return this.setState({
              relatedRecordId: column.value,
              openDrawer: true,
            });
          }
        });
        break;
      default:
        return undefined;
    }
  };

  refreshTable = () => {
    const { fetchData } = this.tableActionsRef;
    fetchData();
  };

  onCloseDrawer = () => {
    this.refreshTable();
    this.setState({
      openDrawer: false,
      isCreate: false,
    });
  };

  onCreate = () => {
    this.setState({
      isCreate: true,
      openDrawer: true,
      relatedRecordId: '00000000-0000-0000-0000-000000000000',
    });
  };

  handleActionMenu = (data, hideMenuFn) => {
    const { isTaskDocument, isTaskDocsCompleted } = this.props;

    const {
      model: { rows },
      rowClicked: { origRowIndex },
    } = data;
    const row = rows[origRowIndex];
    let relatedRecordId;
    row.forEach(column => {
      if (column.columnId === 'id') {
        relatedRecordId = column.value;
      }
    });

    return (
      <Fragment>
        <li key="view details">
          <a
            aria-label="View Details for Row"
            tabIndex={0}
            onClick={() => {
              this.setState({
                relatedRecordId,
                openDrawer: true,
              });
              hideMenuFn(false);
            }}>
            <ListIcon />
            <span className="action-item-text">{intl.get('table.labels.viewDetails')}</span>
          </a>
        </li>
        {!(isTaskDocsCompleted || isTaskDocument) && (
          <li key="delete">
            <a
              aria-label="Delete Row"
              tabIndex={0}
              onClick={() => {
                this.setState({
                  relatedRecordId,
                  showConfirmDialog: true,
                });
                hideMenuFn(false);
              }}>
              <DeleteIcon />
              <span className="action-item-text">{intl.get('table.labels.delete')}</span>
            </a>
          </li>
        )}
      </Fragment>
    );
  };

  onCancelDialog = () => {
    this.setState({
      showConfirmDialog: false,
    });
  };

  onConfirmDialog = () => {
    const { relatedRecordId, del, entityName } = this.state;
    del({ entityId: relatedRecordId, entityName }).then(
      res => {
        this.refreshTable();
      },
      error => {
        this.refreshTable();
      },
    );
    this.setState({
      showConfirmDialog: false,
    });
  };

  getEntityName = entityName => {
    this.setState({ entityName });
  };

  render() {
    //const { openDrawer, isCreate, entityName, fetch, onModifyResponse } = this.state;
    const { openDrawer, isCreate, entityName, fetch } = this.state;

    const {
      area,
      topLevelRecordId,
      parentRecordId,
      additionalProps,
      relationshipName,
      displayName,
      parentEntitySetName,
      parentEntityName,
      getAdditionalPropsForRelatedEntities,
      isTaskDocument,
      isTaskDocsCompleted,
    } = this.props;

    const { sortColumn } = additionalProps;

    return (
      <Fragment>
        {this.state.showConfirmDialog && (
          <ConfirmDialog
            open
            title={intl.get(`${area}.details.confirmDialogTitle`)}
            cancelText={intl.get(`${area}.details.buttons.cancel`)}
            confirmText={intl.get(`${area}.details.buttons.confirm`)}
            onCancel={this.onCancelDialog}
            onConfirm={this.onConfirmDialog}>
            {intl.get(`${area}.details.deleteRecordDialogMessage`)}
          </ConfirmDialog>
        )}
        <TableLanding
          history={this.props.history}
          actionable={true}
          sortDirection={'asc'}
          sortColumn={sortColumn}
          gridFilter={{
            hideFilterButton: true,
            render: TableFilter => (
              <div className="landing-gridfilter-container">
                {TableFilter}
                <Button styleType="primary" onClick={this.onCreate} disabled={isTaskDocument || isTaskDocsCompleted}>
                  <span>{intl.get('table.labels.addButton')}</span>
                </Button>
              </div>
            ),
          }}
          hideLandingHeader={true}
          onRequestData={(params, config) =>
            fetch({ ...params, entitySetName: parentEntitySetName, entityId: parentRecordId, relationshipName }, config)
          }
          // onModifyResponse={onModifyResponse}
          onTableChange={this.onTableChange}
          tableActions={fn => (this.tableActionsRef = fn)}
          actionableRender={this.handleActionMenu}
          getEntityName={this.getEntityName}
          isRelatedEntity
        />
        {openDrawer && (
          <RelatedEntitiesDetailModal
            isCreate={isCreate}
            onClose={this.onCloseDrawer}
            recordId={this.state.relatedRecordId}
            topLevelRecordId={topLevelRecordId}
            parentRecordId={parentRecordId}
            relationshipName={relationshipName}
            displayName={displayName}
            parentEntitySetName={parentEntitySetName}
            parentEntityName={parentEntityName}
            entityName={entityName}
            additionalProps={additionalProps}
            getAdditionalPropsForRelatedEntities={getAdditionalPropsForRelatedEntities}
            area={area}
            readOnly={isTaskDocsCompleted || isTaskDocument}
          />
        )}
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    isTaskDocument: state.caseDatacollectMenu.isTaskDocument,
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(RelatedEntitiesLanding);
